// src/App.jsx
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Composants
import Header from "./components/Header";
import Footer from "./components/Footer";
import PageAccessGuard from "./components/PageAccessGuard";

// Pages publiques
import HomePage from "./pages/HomePage";
import StudioPage from "./pages/StudioPage";
import VideosPage from "./pages/VideosPage";
import Artistes from "./pages/Artistes";
import Latdior from "./pages/Latdior";
import News from "./pages/News";
import ContactPage from "./pages/ContactPage";
import LegalMentions from "./pages/LegalMentions";
import LegalPage from "./pages/LegalPage";
import AuthPage from "./pages/AuthPage";
import AccountPage from "./pages/AccountPage";
import CartPage from "./pages/CartPage";
import BookingPage from "./pages/BookingPage";
import ServicesPage from "./pages/ServicesPage";

// Pages admin
import AdminArtistes from "./pages/admin/AdminArtistes";
import AdminAccueil from "./pages/admin/AdminAccueil";
import AdminNews from "./pages/admin/AdminNews";
import AdminStudio from "./pages/admin/AdminStudio";
import AdminMedias from "./pages/admin/AdminMedias";
import AdminPages from "./pages/admin/AdminPages";
import AdminVideos from "./pages/admin/AdminVideos";
import AdminPlatform from "./pages/admin/AdminPlatform";
import AdminLegalMentions from "./pages/admin/AdminLegalMentions";
import AdminTypography from "./pages/admin/AdminTypography";

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      <Header />

      <Routes>
        {/* 🌍 Routes publiques */}
        <Route path="/" element={<PageAccessGuard pageKey="home"><HomePage /></PageAccessGuard>} />
        <Route path="/studio" element={<PageAccessGuard pageKey="studio"><StudioPage /></PageAccessGuard>} />
        <Route path="/reservation-studio" element={<PageAccessGuard pageKey="booking"><BookingPage /></PageAccessGuard>} />
        <Route path="/services" element={<PageAccessGuard pageKey="services"><ServicesPage /></PageAccessGuard>} />
        <Route path="/services/:serviceId" element={<PageAccessGuard pageKey="services"><ServicesPage /></PageAccessGuard>} />
        <Route path="/videos" element={<PageAccessGuard pageKey="videos"><VideosPage /></PageAccessGuard>} />
        <Route path="/artistes" element={<PageAccessGuard pageKey="artistes"><Artistes /></PageAccessGuard>} />
        <Route path="/latdior" element={<PageAccessGuard pageKey="latdior"><Latdior /></PageAccessGuard>} />
        <Route path="/merch" element={<Navigate to="/latdior" replace />} />
        <Route path="/news" element={<PageAccessGuard pageKey="news"><News /></PageAccessGuard>} />
        <Route path="/contact" element={<PageAccessGuard pageKey="contact"><ContactPage /></PageAccessGuard>} />
        <Route path="/connexion" element={<PageAccessGuard pageKey="login"><AuthPage /></PageAccessGuard>} />
        <Route path="/compte" element={<PageAccessGuard pageKey="account"><AccountPage /></PageAccessGuard>} />
        <Route path="/panier" element={<PageAccessGuard pageKey="cart"><CartPage /></PageAccessGuard>} />
        <Route path="/mentions-legales" element={<PageAccessGuard pageKey="legal"><LegalMentions /></PageAccessGuard>} />
        <Route path="/confidentialite" element={<PageAccessGuard pageKey="legal"><LegalPage title="Politique de confidentialité" type="privacy" /></PageAccessGuard>} />
        <Route path="/cgu" element={<PageAccessGuard pageKey="legal"><LegalPage title="Conditions générales" type="terms" /></PageAccessGuard>} />

        {/* 🔐 Routes admin */}
        <Route path="/admin" element={<AdminPlatform />} />
        <Route path="/admin/accueil" element={<AdminAccueil />} />
        <Route path="/admin/latdior" element={<AdminPlatform />} />
        <Route path="/admin/artistes" element={<AdminArtistes />} />
        <Route path="/admin/news" element={<AdminNews />} />
        <Route path="/admin/studio" element={<AdminStudio />} />
        <Route path="/admin/medias" element={<AdminMedias />} />
        <Route path="/admin/pages" element={<AdminPages />} />
        <Route path="/admin/mentions-legales" element={<AdminLegalMentions />} />
        <Route path="/admin/typographie" element={<AdminTypography />} />
        <Route path="/admin/videos" element={<AdminVideos />} />
        <Route path="/admin/plateforme" element={<AdminPlatform />} />
        <Route path="/admin/services" element={<AdminPlatform />} />
        <Route path="/admin/reservations" element={<AdminPlatform />} />
        <Route path="/admin/commandes" element={<AdminPlatform />} />
        <Route path="/admin/newsletter" element={<AdminPlatform />} />
        <Route path="/admin/messages" element={<AdminPlatform />} />
        <Route path="/admin/notifications" element={<AdminPlatform />} />
        <Route path="/admin/tarifs" element={<AdminPlatform />} />
        <Route path="/admin/parametres" element={<AdminPlatform />} />

        {/* 404 → redirection */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {!isAdmin && <Footer />}
    </>
  );
}
